import React from 'react';
import { TextVariant } from '@naf/text';
import { StepByStepListType, StepByStepListProps, StepByStepListVariant } from './StepByStepList.types';
import BlockContent from '../block-content/BlockContent';
import * as S from './Styles';

const mapVariant = (variant: string): StepByStepListVariant => {
  switch (variant) {
    case 'secondary':
      return StepByStepListVariant.Secondary;
    case 'outline':
    default:
      return StepByStepListVariant.Outline;
  }
};

export const StepByStepList = ({
  title,
  ingress,
  list,
  variant = StepByStepListVariant.Outline,
  listType = StepByStepListType.Numbered,
}: StepByStepListProps) => {
  const onlyTitles = list.every((i) => i.title && (!i.body || i.body.length === 0));

  return (
    <S.Container $variant={mapVariant(variant)} $onlyTitles={onlyTitles} $listType={listType}>
      {title && <S.Title variant={TextVariant.Header3}>{title}</S.Title>}
      {ingress && <S.Ingress>{ingress}</S.Ingress>}
      {list.length > 0 &&
        (onlyTitles ? (
          <ol>
            {list.map((i) => (
              <li key={`step-${i?._key || i.title}`}>
                <S.Step>{i.title}</S.Step>
              </li>
            ))}
          </ol>
        ) : (
          <ol>
            {list.map((i) => (
              <li key={`step-${i?._key || i.title}`}>
                <S.ListContent>
                  {i.title && i.body && (
                    <>
                      <S.Step>{i.title}</S.Step>
                      <S.BodyWrapper $listType={listType}>
                        <BlockContent value={i.body} />
                      </S.BodyWrapper>
                    </>
                  )}
                  {!i.title && i.body && (
                    <S.BodyWrapper $listType={listType}>
                      <BlockContent value={i.body} />
                    </S.BodyWrapper>
                  )}
                </S.ListContent>
              </li>
            ))}
          </ol>
        ))}
    </S.Container>
  );
};

export default StepByStepList;
